import { Suspense, useState, useEffect } from 'react'
import { Await, defer, Link, useSearchParams, useNavigate, useLoaderData, useNavigation, json, Form } from 'react-router-dom'
import { ideaCategory, ideaCategory2, submitIdea, eventidea, getEducationlevel } from '../util/api'
import LoadingSpinner from './components/LoadingSpinner'
import Heading from './helper/Heading'
import { Title } from './helper/DocumentTitle'
import styles from '../styles/module/IdeaNew.module.scss'
import toast from 'react-hot-toast'

const fileTypes = ['jpg', 'jpeg', 'png', 'tif', 'gif', 'pdf', 'doc', 'docx', 'dwg', 'xls', 'xlsx', 'mp4', 'rar', 'zip']

export const loader = async () => {
  return defer({
    user: JSON.parse(localStorage.getItem('Response')),
    eventidea: eventidea(`idea`),
    educationlevel: getEducationlevel(),
  })
}

export default function Idea({ title }) {
  const pageName = title
  Title(pageName)
  const [loaderData, setLoaderData] = useState(useLoaderData())
  const [error, setError] = useState()
  const [data, setData] = useState()
  const [isLoading, setIsLoading] = useState(false)
  const [ideaCategory2Data, setIdeaCategory2Data] = useState([])
  const [category, setCategory] = useState([])
  const [showPopup, setShowPopup] = useState(false)
  const [showCategory1, setShowCategory1] = useState(false)
  const [showCategory2, setShowCategory2] = useState(false)
  const [showCategory2Popup, setShowCategory2Popup] = useState(false)
  const [isSelectedCategory1, setIsSelectedCategory1] = useState(false)
  let [searchParams, setSearchParams] = useSearchParams()
  const navigate = useNavigate()
  const { state } = useNavigation()

  const estimateDay = (date) => {
    let calc = Math.floor((new Date(date).getTime() - new Date().getTime()) / (1000 * 60 * 60 * 24))
    console.log(date)
    return calc
  }

  const nextSlide = () => {
    const slideWidth = document.querySelector('#slide').clientWidth
    document.querySelector('#slides-container').scrollLeft -= slideWidth
  }

  const previesSlide = () => {
    const slideWidth = document.querySelector('#slide').clientWidth
    document.querySelector('#slides-container').scrollLeft += slideWidth
  }

  const handleform = async (e) => {
    const t = toast.loading(`در حال ارسال`)
    setIsLoading(true)
    e.preventDefault()

    const formData = new FormData(document.querySelector(`form`))
    //formData.append('file', document.querySelector('#file').files[0])

    let cat1 = formData.get('ideacategory_id')
    let cat2 = formData.get('ideacategory2_id')
    if (cat1 === '') {
      toast.error(`لطفا دسته بندی را انتخاب کنید`)
      toast.dismiss(t)
      setIsLoading(false)
      return
    }

    if (cat2 === '') {
      toast.error(`لطفا دسته بندی را انتخاب کنید`)
      toast.dismiss(t)
      setIsLoading(false)
      return
    }

    try {
      const res = await submitIdea(formData)
      console.log(res)
      if (res.result) {
        toast.dismiss(t)
        setIsLoading(false)
        navigate(`/idea/list`)
      }
    } catch (error) {
      console.log(error)
      toast.error(`خطایی رخ داده است لطفا مجدد تلاش کنید`)
      toast.error(`${error}`)
      setIsLoading(false)
      toast.dismiss(t)
    }

    return null
  }

  useEffect(() => {
    document.querySelector('header span').innerText = pageName
    ideaCategory(`idea`).then((res) => {
      console.log(res)
      setCategory(res)
    })
  }, [])

  return (
    <section className={styles.section}>
      <Link to={`../`} className="btn btn-back-top">
        بازگشت
      </Link>

      <div className="__frame" data-width={`large`}>
        <div className={styles.formContainer} style={{ border: '2px solid #333' }}>
          <div className="card__body">
            <Suspense fallback={<LoadingSpinner />}>
              <Await resolve={loaderData.eventidea} errorElement={<p></p>}>
                {(data) => {
                  return (
                    <section className={styles.sliderWrapper}>
                      <div className={`animate__animated animate__fadeInDown ${styles.arrows}`} data-count={data.length}>
                        <ul>
                          <li>
                            <button onClick={() => previesSlide()}>&#8249;</button>
                          </li>
                          <li>
                            <button onClick={() => nextSlide()}>&#8250;</button>
                          </li>
                        </ul>
                      </div>

                      <ul className={`animate__animated animate__backInUp ${styles.slidesContainer}`} id="slides-container">
                        {data.map((item, i) => {
                          return (
                            <li className={styles.slide} id="slide" key={i}>
                              <div className={styles.slideInner} style={{ columnGap: '1rem' }}>
                                <div className={styles['imageHolder']} onClick={() => window.open(`${process.env.REACT_APP_UPLOAD}images/${item.img}`, 'new')}>
                                  <img alt={item.title} src={`${process.env.REACT_APP_UPLOAD}images/${item.img}`} />
                                </div>

                                <div className="d-flex flex-column align-items-start justify-content-between" style={{ height: '90%', flex: '1 1 100%' }}>
                                  <h5>{item.title}</h5>
                                  <p style={{ maxWidth: '600px' }}>{item.description}</p>
                                  <p>
                                    {item.file && (
                                      <a href={item.file} style={{ fontWeight: 'bold' }}>
                                        دانلود فایل پیوست
                                      </a>
                                    )}
                                  </p>
                                </div>

                                {estimateDay(`${item.at}`) < 1 ? <span className="alert alert--danger text-center">اتمام یافته</span> : ''}
                              </div>
                            </li>
                          )
                        })}
                      </ul>
                    </section>
                  )
                }}
              </Await>
            </Suspense>

            <Suspense fallback={<LoadingSpinner />}>
              <Await resolve={loaderData.user} errorElement={<p>⚠️</p>}>
                {(data) => {
                  return (
                    <div className={styles.form}>
                      <form className="form" method="post" onSubmit={(e) => handleform(e)}>
                        <input type="hidden" name="page" value="idea" id="" />
                        <div className={styles.formGroup}>
                          <label>
                            دسته بندی<span style={{ color: '#ff0000' }}>*</span>
                          </label>

                          <input type="hidden" name="ideacategory_id" />
                          <input
                            type={`text`}
                            name=""
                            autoComplete="off"
                            placeholder={`جستجو در دسته بندی `}
                            required
                            id="ideacategory_id"
                            onChange={(e) => {
                              if (e.target.value.length > 0) {
                                let filtered = category.filter((item) => item.name.includes(e.target.value))
                                console.log(filtered)
                                if (filtered.length > 0) setCategory(filtered)

                                //reset
                              } else ideaCategory(`idea`).then((res) => setCategory(res))
                            }}
                            onFocus={() => {
                              setShowCategory1(true)
                              ideaCategory(`idea`).then((res) => setCategory(res))
                            }}
                          />

                          {showCategory1 && (
                            <div className={styles['select-popup']}>
                              {category.length < 1 && <>موردی یافت نشد</>}
                              {category.map((item, i) => {
                                return (
                                  <>
                                    <div
                                      key={i}
                                      id={`ideacategory_id_select${i}`}
                                      onClick={() => {
                                        console.log(`d`)
                                        let selectedVal = item.id
                                        ideaCategory2(`idea`).then((res) => {
                                          console.log(res)
                                          setIdeaCategory2Data(res.filter((item) => item.ideacategory_id == selectedVal))
                                        })
                                        document.querySelector("[name='ideacategory_id']").value = item.id
                                        document.querySelector('#ideacategory_id').value = item.name
                                        setShowCategory1(!showCategory1)
                                        setIsSelectedCategory1(true)

                                        //reset
                                        document.querySelector("[name='ideacategory2_id']").value = ''
                                        document.querySelector('#ideacategory2_id').value = ''

                                        //setShowCategory2Popup(!showCategory2Popup)
                                        let filtered = category.filter((catItem) => catItem.id === item.id)
                                        console.log(filtered)
                                        if (filtered.length > 0) setCategory(filtered)
                                      }}
                                    >
                                      {++i}) {item.name}
                                    </div>
                                  </>
                                )
                              })}
                              <button className="btn" onClick={() => setShowCategory1(false)}>
                                بستن
                              </button>
                            </div>
                          )}
                        </div>

                        {isSelectedCategory1 && (
                          <div className={`${styles.formGroup}`}>
                            <label>زیرگروه دسته بندی</label>
                            <input type="hidden" name="ideacategory2_id" />

                            <input
                              type={`text`}
                              name=""
                              autoComplete="off"
                              placeholder={`جستجو در زیرگروه`}
                              required
                              id="ideacategory2_id"
                              onChange={(e) => {
                                if (e.target.value.length > 0) {
                                  let filtered = ideaCategory2Data.filter((item) => item.name.includes(e.target.value))
                                  console.log(filtered)
                                  if (filtered.length > 0) setIdeaCategory2Data(filtered)
                                } else {
                                  ideaCategory2(`idea`).then((res) => {
                                    console.log(res)
                                    setIdeaCategory2Data(res.filter((item) => item.ideacategory_id == document.querySelector("[name='ideacategory_id']").value))
                                  })
                                }
                              }}
                              onFocus={() => {
                                setIsSelectedCategory1(true)
                                setShowCategory2Popup(true)
                              }}
                            />

                            {showCategory2Popup && (
                              <>
                                <div className={styles['select-popup']}>
                                  {ideaCategory2Data.length < 1 && <>موردی یافت نشد</>}
                                  {ideaCategory2Data.map((item, i) => {
                                    return (
                                      <>
                                        <div
                                          key={i}
                                          id={`ideacategory2_id_select${i}`}
                                          onClick={() => {
                                            console.log(`d`)
                                            let selectedVal = item.id
                                            ideaCategory2(`idea`).then((res) => {
                                              console.log(res)
                                              setIdeaCategory2Data(res.filter((item) => item.ideacategory_id == selectedVal))
                                            })
                                            document.querySelector("[name='ideacategory2_id']").value = item.id
                                            document.querySelector('#ideacategory2_id').value = item.name
                                            setShowCategory2Popup(!showCategory2Popup)

                                            ideaCategory2(`idea`).then((res) => {
                                              console.log(res)
                                              setIdeaCategory2Data(res.filter((item) => item.ideacategory_id == document.querySelector("[name='ideacategory_id']").value)) //
                                            })
                                          }}
                                        >
                                          {++i}) {item.name}
                                        </div>
                                      </>
                                    )
                                  })}
                                  <button className="btn" onClick={() => setShowCategory2Popup(false)}>
                                    بستن
                                  </button>
                                </div>
                              </>
                            )}
                          </div>
                        )}

                        <ul className="grid grid--fit grid--gap-1" style={{ '--data-width': '150px' }}>
                          <li>
                            <div className={styles.formGroup}>
                              <label>نام و نام خانوادگی</label>
                              <input
                                type={'text'}
                                name="fullname"
                                placeholder=""
                                defaultValue={data?.firstName !== undefined ? data?.firstName + ' ' + data?.lastName : ''}
                                required
                                readOnly
                              />
                            </div>
                          </li>
                          <li>
                            <div className={styles.formGroup}>
                              <label>موبایل</label>
                              <input type={'number'} name="phone" placeholder="" minLength={11} maxLength={15} defaultValue={data?.mobile} required readOnly />
                            </div>
                          </li>
                          <li style={{ display: 'none' }}>
                            <div className={styles.formGroup}>
                              <label>منطقه</label>
                              <input type={'text'} name="area" placeholder="" required defaultValue={data?.address.traceID} readOnly />
                            </div>
                          </li>
                          <li style={{ display: 'none' }}>
                            <div className={styles.formGroup}>
                              <label>جنسیت</label>
                              <input type={'text'} name="gender" placeholder="" required defaultValue={data?.gender} readOnly />
                            </div>
                          </li>
                          <li>
                            <div className={styles.formGroup}>
                              <label>کدملی</label>
                              <input type={'text'} name="nationalid" placeholder="" required defaultValue={data?.nationalId} readOnly />
                            </div>
                          </li>
                          <li>
                            <div className={styles.formGroup}>
                              <label>تاریخ تولد</label>
                              <input type={'text'} name="birthdate" placeholder="" required defaultValue={data?.birthDateShamsi} readOnly />
                            </div>
                          </li>
                        </ul>

                        <div className={styles.formGroup}>
                          <label>آدرس</label>
                          <input
                            type={'text'}
                            name="address"
                            placeholder=""
                            required
                            defaultValue={
                              data?.address !== undefined ? `${data?.address.province}-${data?.address.street}-${data?.address.street2}-پلاک ${data?.address.houseNumber}` : ''
                            }
                            readOnly
                          />
                        </div>

                        <div className={styles.formGroup}>
                          <label>
                            تحصیلات <span style={{ color: '#ff0000' }}>*</span>
                          </label>
                          <Suspense fallback={<LoadingSpinner />}>
                            <Await resolve={loaderData.educationlevel} errorElement={<p>⚠️Could not load</p>}>
                              {(data) => (
                                <select name="education" required>
                                  <option value="">انتخاب کنید</option>
                                  {data.map((item, i) => {
                                    return (
                                      <option key={i} value={item.name}>
                                        {++i}) {item.name}
                                      </option>
                                    )
                                  })}
                                </select>
                              )}
                            </Await>
                          </Suspense>
                        </div>

                        <div className={styles.formGroup}>
                          <label>
                            تلفن ثابت <span style={{ color: '#ff0000' }}>*</span>
                          </label>
                          <input type={'number'} name="tel" placeholder={`همراه با کد شهر`} required maxLength={12} />
                        </div>

                        {/* <div className={styles.formGroup} style={{display:'none'}}>
                          <label>
                            تلفن همراه <span style={{ color: '#ff0000' }}>*</span>
                          </label>
                          <input type={'number'} name="tel_ergent" placeholder="" required maxLength={12} />
                        </div> */}

                        <div className={styles.formGroup}>
                          <label>
                            عنوان<span style={{ color: '#ff0000' }}>*</span>
                          </label>
                          <input type={'text'} name="title" placeholder="" required />
                        </div>

                        <div className={styles.formGroup}>
                          <label>
                            توضیحات <span style={{ color: '#ff0000' }}>*</span>
                          </label>
                          <textarea type={'text'} name="description" placeholder="" required />
                        </div>

                        <div className="d-flex flex-wrap" style={{ marginBottom: '1rem', columnGap: '1rem', background: '#fff', padding: '1rem', borderRadius: '8px' }}>
                          {[1, 2, 3, 4, 5].map((item, i) => (
                            <>
                              <div className={styles.formGroup}>
                                <label for={`file${item}`} id={`file${item}label`} className={styles['custom-file-upload']}>
                                  انتخاب فایل {item}
                                </label>
                                <input
                                  type={'file'}
                                  name={`file${item}`}
                                  id={`file${item}`}
                                  placeholder=""
                                  onChange={(e) => {
                                    document.querySelector(`#file${item}label`).innerText = e.target.value
                                  }}
                                />
                              </div>
                            </>
                          ))}
                        </div>

                        <p className="alert alert--warning mt-10 border border--warning">
                          حداكثر حجم فايل مجاز 50MB مي باشد 
                          <br />
                          فایل هایی با پسوند
                          <div className="d-flex flex-wrap">
                            {fileTypes.map((item) => (
                              <span className={` badge-pill`} style={{ margin: '0 .2rem', color: '#fff', backgroundColor: 'black' }}>
                                {item}
                              </span>
                            ))}
                          </div>
                          مجاز می باشد
                          <br />
                          مدت زمان فیلم حداکثر 3 دقیقه
                        </p>
                        <div className={styles.formGroup}>
                          <center>
                            <button
                              type="submit"
                              style={{
                                padding: '1rem',
                                background: 'linear-gradient(245.05deg, #AEFB50 13%, #64F49C 47.96%)',
                                color: 'var(--black)',
                                fontWeight: 'bold',
                              }}
                              className={styles.submitButton}
                              disabled={isLoading ? true : false}
                            >
                              ثبت و ارسال
                            </button>
                          </center>
                        </div>
                      </form>
                    </div>
                  )
                }}
              </Await>
            </Suspense>
          </div>
        </div>
      </div>
      <Link to={`../`} className="btn btn-back-bottom">
        بازگشت
      </Link>
    </section>
  )
}
